import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { ifElse, empty, always } from 'ramda'
import withFieldError from 'components/form/with-error'
import { GOOGLE_SHEET_URL_PATTERN } from 'pages/widgets/util'
import { validateRequired } from 'pages/widgets/form/configure-triggers-actions'

// eslint-disable-next-line no-template-curly-in-string
const rowPlaceholder =
  '${senderHandle},Static Value,${eventText},${createdTimestamp}' // eslint-disable-line

const fbRowPlaceholder =
  '${senderId},${senderName},${reactionType},${eventText}' // eslint-disable-line

const sheetUrlPlaceholder =
  'https://docs.google.com/spreadsheets/d/1HYbV7TOR-lcUgGwETmjoJPGnL3JMCHCsTgaVMJlIPnE/edit#gid=162554358'

const isNotValidSheetUrl = string => !GOOGLE_SHEET_URL_PATTERN.test(string)

export const errorMessageIfInvalidSheetUrl = ifElse(
  isNotValidSheetUrl,
  always('Please enter a valid Google Sheet URL'),
  empty
)

export const SheetUrlInput = ({ input, meta: { touched, error } }) => (
  <div>
    <input
      className={
        'form-control right-element-no-borders ' +
        (error && touched ? 'has-error' : '')
      }
      {...input}
      type='url'
      placeholder={sheetUrlPlaceholder}
    />
  </div>
)

SheetUrlInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any
}

export const SheetUrlInputWithError = withFieldError(SheetUrlInput)

export const RowInput = ({ input, meta: { touched, error }, platform }) => {
  return (
    <input
      {...input}
      className={'form-control ' + (error && touched ? 'has-error' : '')}
      placeholder={platform !== 'facebook' ? rowPlaceholder : fbRowPlaceholder}
    />
  )
}

RowInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  platform: PropTypes.string
}

export const RowInputWithError = withFieldError(RowInput)

const GoogleSheetAppendFields = ({ name, platform }) => {
  console.log('this is the platform', platform)
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <Field
          component={SheetUrlInputWithError}
          label='Google Sheet URL'
          name={`${name}.sheetUrl`}
          validate={errorMessageIfInvalidSheetUrl}
        />
      </div>
      <div className='col-sm-12'>
        <Field
          name={`${name}.row`}
          validate={validateRequired}
          component={RowInputWithError}
          platform={platform}
        />
      </div>
    </div>
  )
}

GoogleSheetAppendFields.propTypes = {
  name: PropTypes.string,
  platform: PropTypes.string
}

export default GoogleSheetAppendFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/common/google-sheet-append/index.js